/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkDropdownOptionDto } from '../models/work-dropdown-option-dto';

@Injectable({ providedIn: 'root' })
export class WorkTasktypesV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tasktypesV2ControllerGetAllDropdownOptions()` */
  static readonly TasktypesV2ControllerGetAllDropdownOptionsPath = '/v2/tasktypes/dropdown-options';

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tasktypesV2ControllerGetAllDropdownOptions()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasktypesV2ControllerGetAllDropdownOptions$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkDropdownOptionDto>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTasktypesV2Service.TasktypesV2ControllerGetAllDropdownOptionsPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkDropdownOptionDto>>;
      })
    );
  }

  /**
   * Required permissions: tasks:read, tasks:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tasktypesV2ControllerGetAllDropdownOptions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tasktypesV2ControllerGetAllDropdownOptions(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkDropdownOptionDto>> {
    return this.tasktypesV2ControllerGetAllDropdownOptions$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkDropdownOptionDto>>): Array<WorkDropdownOptionDto> => r.body)
    );
  }

}
